import React, { FC } from 'react';
import { LoadingButton } from '@atlaskit/button';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import type { PaypalButtonConfig, PaypalCallbacks } from '../../common/types';
import { usePaypalSDK } from './paypal';
import './paypal-button.scss';

const loadingButtonStyles = xcss({
  position: 'absolute',
  width: '100%',
});

const paypalButtonContainerStyles = xcss({ position: 'relative' });

export const PaypalButton: FC<{
  parentElementId: string;
  buttonConfig?: PaypalButtonConfig;
  callbacks: PaypalCallbacks;
}> = ({ parentElementId, buttonConfig: paypalButtonConfig, callbacks }) => {
  const { isPaypalButtonRendered } = usePaypalSDK({
    parentElementId,
    callbacks,
    config: paypalButtonConfig,
  });

  return (
    <Flex xcss={paypalButtonContainerStyles} justifyContent="center" direction="column">
      <div id={parentElementId} />
      {!isPaypalButtonRendered && (
        <Box xcss={loadingButtonStyles}>
          <LoadingButton appearance="subtle" isLoading shouldFitContainer />
        </Box>
      )}
    </Flex>
  );
};
